import { Box, Chip, Typography } from '@mui/material';
import { Battery5BarOutlined } from '@mui/icons-material';
import React from 'react';
import StringCard from './StringCard';

const BlockCard = ({
  id,
  data,
}) => {
  const name = data?.block_name || `Block ${id.toUpperCase()}`;
  const strings = Object.entries(data?.battery_strings_data || {});

  return (
    <Box sx={{
      width: "100%",
      boxSizing: "border-box",
      backgroundColor: "var(--c-surface)",
      border: "1px solid var(--c-border)",
      borderRadius: "16px",
      overflow: "hidden",
    }}>
      {/* Header */}
      <Box sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 2.5,
        py: 2,
        borderBottom: "1px solid var(--c-muted)",
      }}>
        <Box sx={{
          width: 36,
          height: 36,
          borderRadius: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "var(--c-accent-bg)",
          color: "var(--c-brand)",
        }}>
          <Battery5BarOutlined fontSize="small" />
        </Box>
        <Typography sx={{ flex: 1, fontSize: 15, fontWeight: 600, color: "var(--c-text)" }} noWrap>
          {name}
        </Typography>
        <Chip
          label={`${strings.length} string${strings.length === 1 ? "" : "s"}`}
          size="small"
          sx={{ height: 22, fontSize: 12, fontWeight: 500, backgroundColor: "var(--c-muted)", color: "var(--c-text-3)" }}
        />
      </Box>

      {/* Strings */}
      {strings.map(([stringId, stringData], index) => (
        <Box key={stringId} sx={{ borderTop: index > 0 ? "1px solid var(--c-border)" : "none" }}>
          <StringCard
            id={stringId}
            label={strings.length > 1 ? `String ${index + 1}` : null}
            data={stringData}
          />
        </Box>
      ))}
    </Box>
  )
}

export default BlockCard;
